import React from "react";

import { Svg } from "./partials/Svg";
import { Group } from "./partials/Group";
import { BarChart } from "./partials/BarChart";
import { ChartProps } from "./Chart";

import { chartColors } from "../../config/colors";
import { margin } from "../../config/spacing";

import climateActionData from "./data/climate-action.json";

export const ClimateAction: React.FC<ChartProps> = ({
  id,
  width = 250,
  height = 400,
  isAnimated = true,
}) => {
  return (
    <Svg id={id} width={width} height={height}>
      <Group transform={`translate(${margin.left}, ${margin.top})`}>
        <BarChart
          data={climateActionData}
          title={"Klimapolitik"}
          description={"Wie viele Länder haben\nausreichende Klimaschutzpläne?"}
          unit={"Länder"}
          source={"CAT"}
          sourceLink={"https://climateactiontracker.org/"}
          infoLink={"https://www.ardalpha.de/klimazahlen-klimapolitik-102.html"}
          isAnimated={isAnimated}
        />
      </Group>
    </Svg>
  );
};
